<template>
  <div class="youtube-user">
    <div class="header"><span>YouTube用户管理</span></div>
    <div class="container">
      <el-button type="primary" @click="addUser">添加用户</el-button>
      <div class="table">
        <el-table
          :border="false"
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          height="100%"
        >
          <el-table-column prop="youtubeUserName" label="用户名" width="200"></el-table-column>
          <el-table-column prop="credential" label="凭证"></el-table-column>
          <el-table-column prop="operate" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" @click="authoriizeUser(scope.row)">授权</el-button>
              <el-button type="text" @click="revertUser(scope.row)">撤销</el-button>
              <el-button type="text" @click="relateSystemUser(scope.row)">关联系统用户</el-button>
              <el-button type="text" @click="deleteUser(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="添加用户"
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      width="500px"
    >
      <div class="dialog-content">
        <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="90px">
          <el-form-item prop="youtubeUserName" label="用户名：">
            <el-input
              style="width: 320px"
              placeholder="请输入用户名"
              v-model="ruleForm.youtubeUserName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="file" label="凭证：">
            <el-upload
              v-loading="uploadLoading"
              class="upload-item"
              :action="actionUrl"
              :on-change="uploadFiles"
              :before-remove="deleteFiles"
              :multiple="false"
              :limit="1"
              :on-exceed="onExceed"
              :auto-upload="false"
              ref="upload"
            >
              <el-button type="primary">上传文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modalVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="关联系统用户"
      :close-on-click-modal="false"
      :visible.sync="relateModalVisible"
      width="500px"
    >
      <div class="dialog-content">
        <el-form :rules="rules" :model="userForm" ref="ruleForm" label-width="90px">
          <el-form-item prop="user" label="用户：">
            <el-select
              v-model="userForm.user"
              multiple
              style="width: 340px"
              placeholder="请选择用户"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="relateModalVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmRelateUser">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :close-on-click-modal="false"
      :visible.sync="policyModalVisible"
      width="500px"
    >
      <div class="dialog-content">
        <el-checkbox v-model="isPolicyChecked"></el-checkbox>
        已阅读
        <a class="a-link" href="https://www.youtube.com/t/terms" target="_blank">
          YouTube Terms of Service</a
        >
        和
        <a class="a-link" href="http://www.google.com/policies/privacy" target="_blank"
          >Google Private Policy</a
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loginYoutube" :disabled="!isPolicyChecked"
          >登录YouTube</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addYoutubeUserInfo,
  getYoutubeUserList,
  deleteYoutubeUser,
  authoriizeYoutubeUser,
  bindYoutubeUser,
  revokeYoutubeUser,
} from "@/api/property.js";
import { getUserInfoList } from "@/api/api.js";
export default {
  components: {},

  data() {
    return {
      tableData: [],
      loading: false,
      modalVisible: false,
      relateModalVisible: false,
      policyModalVisible: false,
      isPolicyChecked: false,
      userId: "",
      ruleForm: {
        youtubeUserName: "",
        file: null,
      },
      userForm: {
        user: [],
      },
      uploadLoading: false,
      rules: {
        youtubeUserName: [{ required: true, message: "请输入用户名", trigger: "change" }],
        file: [{ required: true, message: "请上传凭证", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      actionUrl: `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}/youtube/newFiles`,
      userList: [],
      userData: {},
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      getYoutubeUserList().then((res) => {
        this.tableData = res.data;
      });
    },
    addUser() {
      this.ruleForm = {
        youtubeUserName: "",
        file: null,
      };
      this.modalVisible = true;
    },

    authoriizeUser(data) {
      this.policyModalVisible = true;
      this.userId = data.id;
    },
    loginYoutube() {
      authoriizeYoutubeUser({ id: this.userId }).then((res) => {
        if (res.code === "0000") {
          window.open(res.data, "_blank");
        }
      });
    },
    revertUser(data) {
      this.$confirm("确定撤销用户“" + data.youtubeUserName + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          revokeYoutubeUser({
            id: data.id,
          })
            .then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getList();
              }
            })
            .cartch(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    relateSystemUser(data) {
      this.userData = data;
      this.userForm.user = data.userIds;
      this.relateModalVisible = true;
      getUserInfoList({
        orgIds: 254,
      }).then((res) => {
        this.userList = res.data;
      });
    },
    handleConfirmRelateUser() {
      bindYoutubeUser({
        userIds: this.userForm.user.join(","),
        id: this.userData.id,
      }).then((res) => {
        this.relateModalVisible = false;
        if (res.code === "0000") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getList();
        }
      });
    },
    deleteUser(row) {
      this.$confirm("确定删除用户“" + row.youtubeUserName + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteYoutubeUser({ id: row.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    beforeVideoUpload(file) {
      let fileArr = file.name.split(".");
      let suffix = fileArr[fileArr.length - 1];
      if (!["json", "jsonp"].includes(suffix)) {
        this.$message.warning("视频格式只能是json格式!");
        return;
      }
      //不能导入大小超过5Mb的视频
      if (file.size > 5 * 1024 * 1024) {
        this.$message("文件过大，请上传小于5MB的文件〜");
        return false;
      }
      return true;
    },
    onExceed() {
      this.$refs.upload.clearFiles();
    },
    deleteFiles() {
      this.ruleForm.file = null;
    },
    uploadFiles(file) {
      //判断是否符合beforeVideoUpload方法中的条件
      if (this.beforeVideoUpload(file)) {
        this.ruleForm.file = file;
        this.$refs.ruleForm?.clearValidate(["file"]);
      } else {
        this.$refs.upload.clearFiles();
      }
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const { youtubeUserName, file } = this.ruleForm;
          const fileFormData = new FormData();
          fileFormData.append("file", file.raw, file.name);
          addYoutubeUserInfo(fileFormData, youtubeUserName)
            .then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.modalVisible = false;
                this.$message.success("添加成功");
                this.getList();
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.youtube-user {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 38px");
  background: #ffffff;
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .container {
    height: calc(~"100% - 144px");
    padding: 16px 24px;
    .table {
      margin-top: 20px;
      height: 100%;
    }
  }
  .a-link {
    text-decoration: none;
  }
}
</style>
